import mainApi from "./mainApi";
import newsApi from "./newsApi";

export default [...mainApi, ...newsApi];
